
export type ChatUserSearchResponseContentItem = {
  /** @nullable */
  avatarUrl?: string | null;
  displayName: string;
  userId: string;
  userName: string;
};
